export const maritalStatusOptions = [
  { label: 'Solteiro', value: 'solteiro' },
  { label: 'Casado', value: 'casado' },
];
